import axios from "axios";

export class ContractOTCService {
    /**
     * Función que hace una llamada al back para consultar la lista para
     * llenar la pantalla de contrato bilateral.
     * @returns {Promise<any>} Respuesta que contiene la lista de
     * contratos o regresa un error, cuando no puede consultar.
     */
    getBilateralAgreement() {
        return axios.get('/appapv/getBilateralAgreement.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    /**
     * Función que hace put al back para modificar un contrato
     * previamente seleccionado.
     * @param objectContract Objeto a editar
     * @returns {Promise<any>} Mensaje de éxito o error al modificar el contrato.
     */
    editBilateralAgreement(params) {
        return axios.put('/appapv/editBilateralAgreement.action', {}, {
            params: params
        }).then(res => {
            this.getBilateralAgreement();
            return res.data;
        });
    }
}